import Layout from "@/page/index/";
export default [
  {
    path: "/login",
    name: "登录页",
    // component: () =>
    //     import( /* webpackChunkName: "page" */ '@/page/login/index'),
    component: (resolve) => require(["@/page/login/index"], resolve),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false,
    },
  },
  {
    path: "/lock",
    name: "锁屏页",
    // component: () =>
    //     import( /* webpackChunkName: "page" */ '@/page/lock/index'),
    component: (resolve) => require(["@/page/lock/index"], resolve),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false,
    },
  },
  {
    path: "/404",
    // component: () =>
    //     import( /* webpackChunkName: "page" */ '@/components/error-page/404'),
    component: (resolve) => require(["@/components/error-page/404"], resolve),
    name: "404",
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false,
    },
  },
  {
    path: "/403",
    component: () =>
      import(/* webpackChunkName: "page" */ "@/components/error-page/403"),
    name: "403",
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false,
    },
  },
  {
    path: "/500",
    component: () =>
      import(/* webpackChunkName: "page" */ "@/components/error-page/500"),
    name: "500",
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false,
    },
  },
  {
    path: "/training",
    component: Layout,
    redirect: "/training/course-manage",
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false, // 本地测试，不需要鉴权
    },
    children: [
      {
        path: "course-manage",
        name: "课程管理",
        component: () =>
          import(
            /* webpackChunkName: "training" */ "@/menu/training/course-manage/index.vue"
          ),
        meta: {
          keepAlive: true,
          isTab: false,
          isAuth: false, // 本地测试，不需要鉴权
        },
      },
      {
        path: "exam-manage",
        name: "考试管理",
        component: () =>
          import(
            /* webpackChunkName: "training" */ "@/menu/training/exam-manage/index.vue"
          ),
        meta: {
          keepAlive: true,
          isTab: false,
          isAuth: false, // 本地测试，不需要鉴权
        },
      },
    ],
  },
  {
    path: "/",
    name: "主页",
    redirect: "/wel",
  },

  {
    path: "/myiframe",
    component: Layout,
    redirect: "/myiframe",
    children: [
      {
        path: ":routerPath",
        name: "iframe",
        // component: () =>
        //     import( /* webpackChunkName: "page" */ '@/components/iframe/main'),
        component: (resolve) => require(["@/components/iframe/main"], resolve),
        props: true,
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
  },
];
